export enum FEATURE_FLAGS {
  exampleFF = 'example_ff',
  facebookAuth = 'sso_facebook_login',
  ssoRevamp = 'sso_revamp',
}
